export default "__VITE_ASSET__XOh_$abQ__"